import { Box, Grid, Typography } from '@mui/material'
import { CapacityGraph } from './Capacity.graph'
import { useTheme } from '@mui/material/styles'
import { WorkCentreDashboardPageParams } from '../WorkcentreDashboard.types'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { useWorkcentreKPIs } from 'Common/Hooks/UseWorkcentreKPIs.hooks'
import { formatDateWithHiphen } from 'Common/utils/utils'
import { useCapacity } from 'Features/SourceSiteDashboard/SourceSiteDashboard.data'
export const CapacityView = () => {
  const theme = useTheme()

  const { workcentreId, planId } = useParams<WorkCentreDashboardPageParams>()

  const { data: capacityData, isLoading: isCapacityDataLoading } = useCapacity({
    workcentresList: workcentreId ? [workcentreId] : [],
    planId: planId ?? '',
  })

  const [kpis] = useWorkcentreKPIs(planId ?? '', workcentreId ?? '')

  if (isCapacityDataLoading) {
    return <Loader />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Grid container>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Constrained
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            utilisation
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.capacityUtilisationConHorizon
              ? `${kpis?.capacityUtilisationConHorizon}%`
              : 'N/A'}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Over capacity
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            hours
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.hoursOverCapacity ?? 'N/A'}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Utilisation in
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            unconstrained period
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.capacityUtilisationUnconHorizon
              ? `${kpis?.capacityUtilisationUnconHorizon}%`
              : 'N/A'}
          </Typography>
        </Grid>
      </Grid>
      <Box>
        <CapacityGraph
          xAxisData={capacityData?.weeks?.map(formatDateWithHiphen) ?? []}
          promisedCapacity={capacityData?.capacityScatterData ?? []}
          underCapacity={capacityData?.underCapacityData ?? []}
          overCapacityData={capacityData?.overCapacityData ?? []}
          equalCapacityData={capacityData?.equalCapacityData ?? []}
          unconstrainedHoursData={capacityData?.uncontrainedHoursData}
        />
      </Box>
    </Box>
  )
}
